import React, {useState} from "react";
import {Box, Button, Card, CardContent, CircularProgress, Divider, Grid, Typography} from "@mui/material";
import {formatDate} from "~/apps/core/utils";
import moment from "moment/moment";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {OrderCargoCard} from "~/apps/packages/auto-shipment-orders/components/OrderDetail/OrderCargoCard/OrderCargoCard";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {OrdersListStatusBadge} from "~/apps/packages/auto-shipment-orders/components/OrdersList/OrdersListStatusBadge";
import {InformationCircle, LockClose} from "~/ui/icons";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {Tag} from "~/apps/core/ui/Tag";
import {OrderItem} from "~/apps/packages/auto-shipment-orders/queries";

type OrderDetailProps = {
    order: OrderItem
}

export const OrderDetail = (props: OrderDetailProps) => {
    const {
        order
    } = props;
    const [isOnEdit, setOnEdit] = useState(false);
    const handleEditClick = () => {
        setOnEdit(true)
    }

    const handleSaveClick = () => {
        setOnEdit(false)
    }

    return (
        <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
            <Grid item>
                <Card>
                    <CardContent>
                        <Grid container direction="column" wrap="nowrap" rowSpacing="8px">
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <OrdersListStatusBadge>
                                        {order.status}
                                    </OrdersListStatusBadge>
                                </Grid>
                                <Grid item>
                                    <Typography variant="cardText">
                                        {formatDate(moment(order.date, "YYYY-MM-DD"))}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="cardTitle2" color="#081F32">
                                        {order.number}
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <TypographyWithIcon variant="cardText" color="additionalPrimary.main"
                                                        startIcon={<LockClose style={{width: 16, height: 16}}/>}>
                                        PIN {order.pin || <>&ndash;&ndash;&ndash;&ndash;</>}
                                    </TypographyWithIcon>
                                </Grid>
                            </Grid>
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <TypographyWithLabel label="Договор">
                                        {order?.contract?.number}
                                    </TypographyWithLabel>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item>
                <Card>
                    <CardContent>
                        <Grid container direction="column" wrap="nowrap" rowSpacing="8px">
                            {order.shipmentByConsignee &&
                                <>
                                    <Grid item>
                                        <Box
                                            padding="8px"
                                            sx={{
                                                borderRadius: '3px',
                                                backgroundColor: 'rgba(63, 121, 181, 0.12)'
                                            }}
                                        >
                                            <Typography variant="cardText">
                                                Вывоз грузополучателем
                                            </Typography>
                                            <Typography variant="screenSubtitle" color="#8797A9" display="block">
                                                Самоходный груз/ ТС грузоподъемностью до 6т (кроме седельных тягачей)
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Divider/>
                                    </Grid>
                                </>}
                            {order.shipmentByConsignee && order.consignee && <>
                                <Grid item>
                                    <TypographyWithLabel label="Грузополучатель">
                                        {typeof order.consignee !== "string" ? order.consignee?.name : order.consignee}
                                    </TypographyWithLabel>
                                </Grid>
                                <Grid item>
                                    <TypographyWithLabel label="Документ грузополучателя">
                                        {typeof order.consignee !== "string" ? order.consignee?.document : '-'}
                                    </TypographyWithLabel>
                                </Grid>
                            </>}
                            {
                                !order.shipmentByConsignee && order.carrier && <>
                                    <Grid item>
                                        <TypographyWithLabel label="Перевозчик">
                                            {typeof order.carrier !== "string" ? order.carrier?.name : order.carrier}
                                        </TypographyWithLabel>
                                    </Grid>
                                </>
                            }
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item container direction="row" justifyContent="space-between">
                <Typography variant="screenText" color="primary">
                    Грузы
                </Typography>
            </Grid>
            {
                order.cargos && order.cargos.map((item) =>
                    <Grid item key={item.id}>
                        <OrderCargoCard cargo={item} />
                    </Grid>
                )
            }

            <>
                <Box height={136} minHeight={136}/>
                {isOnEdit
                    ? <FloatingActions>
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleSaveClick}
                            //disabled={disabledEdit}
                        >
                            Сохранить
                        </Button>
                    </FloatingActions>
                    : <FloatingActions>
                        <Button
                            fullWidth
                            color="primary"
                            onClick={handleEditClick}
                            //disabled={disabledEdit}
                        >
                            Изменить
                        </Button>

                        <Button
                            fullWidth
                            color="secondary"
                            //startIcon={canceling && <CircularProgress size={16} color="inherit"/>}
                            //disabled={disabledEdit || canceling}
                            //onClick={handleCancelClick}
                        >
                            {/*{canceling ? "Отмена" : "Отменить"}*/}
                            Отменить
                        </Button>
                </FloatingActions>}
            </>
        </Grid>
    );
}